import React from "react";

const TableHead = ({ children }) => {
    return (
        <thead className="table__head">
            <tr className="table__row">{children}</tr>
        </thead>
    );
};

TableHead.propTypes = {};
TableHead.defaultProps = {};

export default TableHead;
